import React, { useState, useMemo, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import CrossIcon from "../../icons/cross.icon";
import useDropdown from "../../../hooks/dropdown.hook";
import ImageLoader from "../../Common/ImageLoader";
import OrderSummary from "../../Common/loader";
import { HGHighlightText } from "../../App/App";
import PlusIcon from "../../icons/plus.icon";
import styles from "./linked-products-selector.module.scss";
import cn from "../../../Utils/class-names.utils";
import SearchInput from "../../search-input/search-input.component";

const LinkedProductsSelector = ({
  tool,
  list,
  selectedList,
  onAdd = () => { },
  onRemove = () => { },
  onOpen = () => { },
  onSearch = () => { },
  onLoadMore = () => { },
  isLoading = false,
  isCreating = false,
  enableCreate = false,
  max = null,
  setIsOpenState = () => { },
  onShowMoreClick = () => { },
  onAddNewProduct = () => { },
  isView = false,
}) => {
  const [searchProductId, setSearchProductId] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [search, setSearch] = useState("");
  const [searchTimer, setSearchTimer] = useState(null);
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({ disableClickOutside: false });

  const filteredList = useMemo(() => (
    (
      !search
        ? list
        : list?.filter(item => item?.Name?.toLowerCase().includes(search?.toLowerCase()))
    ).filter(item => !selectedList?.some(selectedItem => String(selectedItem?.ObjectId) === String(item?.ObjectId)))
  ), [search, selectedList, list]);

  const curSelectedList = useMemo(() => (
    showMore ? selectedList : [...selectedList]?.slice(0, 1)
  ), [selectedList, showMore]);

  const moreProductsAmount = selectedList?.length - 1;

  const loadMore = async (e) => {
    if (isLoading) return;
    try {
      if (
        e.target.clientHeight + e.target.scrollTop + 100 >=
        e.target.scrollHeight
      ) {

        let element = document.getElementById("multiple-scroll-list");
        element.removeEventListener("scroll", loadMore);
        await onLoadMore();
      }
    } catch (error) {
      console.log("errror", error);
    }
  }

  const handleSearch = (value) => {
    if (value === search) return;
    setSearch(value);
    if (searchTimer) {
      clearTimeout(searchTimer);
    }
    setSearchTimer(setTimeout(() => {
      onSearch(value);
      setSearchTimer(null);
    }, 500));
  }

  useEffect(() => {
    setIsOpenState(isOpen);
    if (isOpen) {
      onOpen();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isLoading) return;
    var element = document.getElementById("multiple-scroll-list");
    if (element) {
      element.removeEventListener("scroll", loadMore);
      element.addEventListener("scroll", loadMore);

      return () => {
        element.removeEventListener("scroll", loadMore);
      };
    }
  }, [list, isLoading, isOpen]);

  useEffect(() => {
    const newId = `select-tool-search-product-${Date.now()}`;
    setSearchProductId(newId);
  }, []);

  return (
    <div className={`d-flex flex-wrap ${styles.addInput}`}>
      {curSelectedList?.map((item) => (
        <div className={styles.selectItem} key={`item-selected-${item.ObjectId}`}>
          <span
            className={cn("w-100", {
              "pointer": !isView
            })}
            onClick={!isView ? () => { onAddNewProduct(tool, item?.ObjectId); } : undefined}
          >
            {item.Name}
          </span>
          {!isView && (
            <div
              className="pointer"
              onClick={() => {
                onRemove(item);
                setShowMore(true);
              }}
            >
              <CrossIcon fill="#616778" width="10px" height="10px" style={{ marginBottom: '2px' }} />
            </div>
          )}
        </div>
      ))}
      {(!showMore && selectedList?.length > 1) && (
        <div
          className={`${styles.selectItem} pointer`}
          onClick={() => {
            setShowMore(true);
            onShowMoreClick();
          }}
        >
          <span>{`+ ${moreProductsAmount} product${moreProductsAmount !== 1 ? 's' : ''}`}</span>
        </div>
      )}
      {!isView && (
        <Dropdown
          dir="right"
          show={isOpen}
          className={cn(styles.linkProductSelectedDropdown, "link-product-selected-dropdown transparennt-wrapper-dropdown my-dropdown my-dropdown-common")}
        >
          {((max && selectedList?.length < max) || max == null) && (
            <Dropdown.Toggle ref={refBtn} className={`w-100 d-flex ${styles.linkProductSelectedToggle}`}>
              <div
                className={`${styles.selectToolBtn} d-flex align-items-center pointer w-100`} onClick={(isOpen) => {
                  setIsOpen(prev => !prev);
                  if (isOpen) {
                    setTimeout(() => {
                      const searchElem = document.getElementById(searchProductId);
                      searchElem?.focus();
                    }, 100);
                  }
                }}
              >
                <input
                  type="text"
                  value={search}
                  onChange={e => {
                    handleSearch(e.target.value);
                    setIsOpen(true);
                    setTimeout(() => {
                      const searchElem = document.getElementById(searchProductId);
                      searchElem?.focus();
                    }, 100);
                  }}
                  placeholder="Add"
                  className={`border-0 ${styles.input} w-100`}
                />
              </div>
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu
            ref={refMenu}
            className="w-100 menu"
            popperConfig={{
              strategy: 'fixed'
            }}
            renderOnMount
          >
            <div>
              <SearchInput
                value={search}
                onChange={handleSearch}
                placeholder="Search"
                className="bg-white pt-0 px-0"
                id={searchProductId}
              />
            </div>
            <div id="multiple-scroll-list" className={styles.transparentScroller}>
              {filteredList?.length > 0 ? filteredList?.map(item => (
                <Dropdown.Item
                  key={`item-${item.ObjectId}`}
                  onClick={() => {
                    onAdd(item);
                    setIsOpen(false);
                    setSearch("");
                    setShowMore(true);
                  }}
                  className="px-2"
                >
                  <ImageLoader
                    src={item.Icon}
                    alt=""
                    className=""
                    width={16}
                    height={16}
                    noImageComponent={(
                      <img src="/images/msp/no-product-image.png" width={16} height={16} />
                    )}
                  />
                  <span
                    className="ml-2"
                    dangerouslySetInnerHTML={{ __html: HGHighlightText(
                      `${item.Name?.slice(0, 35)}${item.Name?.length >= 35 ? '...' : ''}`, 
                      search
                      ) }}
                  />
                </Dropdown.Item>
              )) : !isLoading ? (
                <div className="my-2 f-darkgrey w-100 pl-4 h-100">No data found</div>
              ) : null}
              {isLoading && (
                <OrderSummary />
              )}
            </div>
            <div className={styles.divider} />
            <div className={`d-flex align-items-center gap-8 pointer ${styles.addNewProduct}`} onClick={() => { onAddNewProduct(tool, 0, search); }}>
              <PlusIcon fill="#008FD4" width={12} height={12} />
              <span className="f-14 line-height-22 f-blue">Add {search ? `"${search}"` : 'New Product'}</span>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  )
}

export default LinkedProductsSelector;
